<template>
  <div class="wrapper">
    <div class="form">
      <van-notice-bar
        v-if="exchangeOrderInfo"
        :text="exchangeStatusMap[exchangeOrderInfo.status]"
      />
      <van-form @submit="onSubmit">
        <div class="formWrapper">
          <div
            class="panel"
            v-if="exchangeOrderInfo && exchangeOrderInfo.status == '2'"
          >
            <div class="title">未通过原因</div>
            <div class="discription" style="color: red">
              <van-icon name="warning-o" /> {{ exchangeOrderInfo.failedReason }}
            </div>
          </div>
          <div class="panel">
            <div class="title">激活码信息</div>
            <van-field
              :readonly="!isEdit"
              v-model="formData.code"
              name="code"
              label="激活码"
              placeholder="请输入激活码"
              :rules="[{ required: true, message: '请填写激活码' }]"
            >
              <van-icon
                v-if="isEdit"
                @click="codeScan"
                slot="right-icon"
                name="scan"
              />
            </van-field>
            <van-field
              :readonly="true"
              v-model="formData.groupName"
              name="groupName"
              label="商品名称"
              left-icon="warning-o"
              rows="2"
              type="textarea"
              @click-left-icon="showMark"
              placeholder="请输入商品名称"
              :rules="[{ required: true, message: '请填写商品名称' }]"
            />
          </div>
          <div class="panel">
            <div class="title">产品信息</div>
            <van-field
              :readonly="!isEdit"
              clickable
              name="picker"
              :value="brandName"
              required
              label="品牌"
              :rules="[{ required: true, message: '请选择品牌' }]"
              placeholder="点击选品牌"
              @click="showPicker = true"
            />
            <van-field
              :readonly="!isEdit"
              v-model="formData.model"
              name="model"
              label="型号"
              required
              placeholder="请输入型号"
              :rules="[{ required: true, message: '请填写型号' }]"
            />
            <van-field
              :readonly="!isEdit"
              v-model="formData.memory"
              name="memory"
              label="内存"
              required
              placeholder="请输入内存"
              :rules="[{ required: true, message: '请填写内存' }]"
            />
            <van-field
              :readonly="!isEdit"
              v-model="formData.serialNum"
              name="serialNum"
              label="串号"
              required
              placeholder="请输入串号"
              :rules="[{ required: true, message: '请填写串号' }]"
            >
              <van-icon
                v-if="isEdit"
                @click="serialScan"
                slot="right-icon"
                name="scan"
              />
            </van-field>
          </div>
          <div class="panel">
            <div class="title">用户信息</div>
            <van-field
              :readonly="true"
              v-model="formData.userName"
              name="userName"
              label="姓名"
              placeholder="请输入姓名"
            />
            <van-field
              type="tel"
              name="userPhone"
              v-model="formData.userPhone"
              label="手机号"
              :maxlength="11"
              placeholder="请输入手机号"
            />
            <van-field
              class="picker-field"
              :class="purchasTime && 'picker-inputed'"
              clickable
              name="picker"
              :readonly="!isEdit"
              :value="purchasTime"
              required
              label="购机时间"
              :rules="[{ required: true, message: '请选择购机时间' }]"
              placeholder="点击选择购机时间"
              @click="showTime = true"
            />
            <van-field
              v-model="formData.money"
              :type="!isEdit ? 'string' : 'number'"
              name="money"
              :readonly="!isEdit"
              label="购机价格"
              required
              placeholder="请输入购机价格"
              :rules="[{ required: true, message: '请填写购机价格' }]"
            />
          </div>
          <div class="panel">
            <div class="title">门店信息</div>
            <van-field
              v-model="formData.sellName"
              :readonly="true"
              name="sellName"
              label="销售员姓名"
              placeholder="请输入销售员姓名"
            >
            </van-field>
            <van-field
              v-model="formData.sellPhone"
              type="tel"
              :readonly="true"
              name="sellPhone"
              label="销售员手机号"
              :maxlength="11"
              placeholder="请输入销售员手机号"
            />
          </div>
          <div class="panel">
            <div class="title">凭证信息</div>
            <div class="discription">
              提示:
              <p>1、完整主屏幕，常亮状态下*#06#显示出串号（手机务必照全）</p>
              <p>
                2、完整购机凭证盖门店销售章，需填写用户姓名、电话、日期、机型、串号、价格，不可遮挡；
              </p>
              <p>
                3、完整保修卡盖章，需填写用户姓名、电话、日期、串码标，不可遮挡；
              </p>
              <p>4、百度搜索显示北京时间。</p>
              <p>5、如换机，需将售后工单与新机常亮状态*06#显示出串号（手机务必照全）一起拍照。</p>
            </div>
            <van-button
              v-if="showImgUrl"
              style="width: 100%"
              @click="
                (e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  openPreview([showImgUrl]);
                }
              "
            >
              预览图片
            </van-button>
            <van-uploader
              accept="image/*"
              :disabled="!isEdit"
              :after-read="afterRead"
              :max-size="20 * 1024 * 1024"
              @oversize="overSizeTip"
            >
              <img v-if="showImgUrl" style="width: 100%" :src="showImgUrl" />
              <van-button
                v-else
                class="upladerBtn"
                icon="plus"
                type="primary"
              ></van-button>
            </van-uploader>
          </div>
        </div>
        <div v-if="isEdit" style="margin: 16px">
          <van-button round block type="danger" native-type="submit"
            >提交更换报备</van-button
          >
        </div>
      </van-form>
      <div style="margin: 16px">
        <van-button
          v-if="
            (!exchangeOrderInfo && !isEdit) ||
            (exchangeOrderInfo &&
              exchangeOrderInfo.status != 0 &&
              exchangeOrderInfo.status != 1 &&
              !isEdit)
          "
          round
          block
          type="danger"
          @click="onEdit"
          >修改信息</van-button
        >
      </div>
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="brandList"
          value-key="brandName"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        >
        </van-picker>
      </van-popup>
      <van-popup v-model="showTime" position="bottom">
        <van-datetime-picker
          v-model="formData.purchasTime"
          type="date"
          @confirm="onConfirm2"
          @cancel="showTime = false"
          title="选择年月日"
        />
      </van-popup>
    </div>
    <loadingMask :isShow="showLoding" />
  </div>
</template>

<script>
import {
  uploadExchangeImg,
  addExchange,
  getBrandList,
  getUserInfo,
  userGetOrder,
  getExchangeOrder,
  updateExchangeOrder,
} from "@/api";
import { baseURL } from "@/config";
import loadingMask from "@/components/loadingMask.vue";
import { exchangeStatusMap, checkImgFun } from "@/utils/common.js";
import dayjs from "dayjs";
import { getScanCode } from "@/utils/wxSDK";
import { openPreview } from "@/utils";
import { Dialog } from "vant";
export default {
  name: "codeDetail",
  components: {
    loadingMask,
  },
  data() {
    return {
      baseURL,
      formData: {
        code: "",
        codeCertificate: "",
        serialNum: "",
        userName: "",
        userPhone: "",
        money: "",
        brandId: "",
        groupMark: "",
        purchasTime: new Date(),
        sellName: "",
        sellPhone: "",
        memory: "",
        model: "",
      },
      showImgUrl: "",
      isEdit: false,
      purchasTime: dayjs().format("YYYY-M-D"),
      code: this.$route.query.code,
      codeId: "",
      exchangeStatusMap,
      brandName: "",
      brandList: [],
      showLoding: false,
      showPicker: false,
      showTime: false,
      exchangeOrderInfo: null,
      money: "",
    };
  },
  mounted() {
    window.document.title = "激活码";
    this.getUserInfoFun();
  },
  methods: {
    openPreview,
    showMark() {
      Dialog.alert({
        title: "商品描述",
        message: this.formData.groupMark,
        theme: "round-button",
      }).then(() => {
        // on close
      });
    },
    onEdit() {
      this.isEdit = true;
      this.formData.money = this.money;
    },
    codeScan() {
      getScanCode().then((res) => {
        this.formData.code = res;
      });
    },
    serialScan() {
      getScanCode().then((res) => {
        this.formData.serialNum = res;
      });
    },
    overSizeTip() {
      this.$toast("上传图片不能超过20M");
    },
    onSubmit(e) {
      this.showLoding = true;
      let data = JSON.parse(JSON.stringify(this.formData));
      const {
        code,
        userPhone,
        brandId,
        model,
        memory,
        serialNum,
        picture,
        money,
        id,
      } = data;
      const fun =
        this.exchangeOrderInfo && this.exchangeOrderInfo.status == 2
          ? updateExchangeOrder
          : addExchange;
      fun({
        code,
        brandId,
        model,
        memory,
        userPhone,
        serialNum,
        picture,
        purchasTime: this.purchasTime,
        money,
        id,
      }).then((res) => {
        const response = res.data;
        if (response.code === "200") {
          this.$toast.success({
            message: "信息已提交，等待工作人员审核",
            duration: 5000,
          });
          this.getUserInfoFun();
        } else {
          this.$toast.fail(response.msg);
        }
        this.showLoding = false;
      });
    },
    onConfirm(value) {
      this.brandName = value.brandName;
      this.formData.brandId = value.brandId;
      this.showPicker = false;
    },
    onConfirm2(value) {
      this.formData.purchasTime = value;
      this.purchasTime = dayjs(value).format("YYYY-M-D");
      this.showTime = false;
    },
    async getUserInfoFun() {
      await getBrandList().then((res) => {
        const response = res.data;
        if (response.code === "200") {
          this.brandList = response.data;
        }
      });
      await getUserInfo({
        keyword: this.code,
      }).then((res) => {
        const response = res.data;
        if (response.code === "200") {
          this.brandName = response.data[0].brandName;
          this.money = response.data[0].money;
          response.data[0].money = "****";
          this.purchasTime = dayjs(response.data[0].purchasTime).format(
            "YYYY-M-D"
          );
          this.codeId = response.data[0].codeId;
          checkImgFun(response.data[0].codeCertificate).then((url) => {
            this.showImgUrl = url;
          });
          this.formData = response.data[0];
        }
      });
      await getExchangeOrder({
        code: this.code,
      }).then((res) => {
        const { data: response } = res;
        this.exchangeOrderInfo = response.data;
        if (this.exchangeOrderInfo) {
          checkImgFun(this.exchangeOrderInfo.picture).then((url) => {
            this.showImgUrl = url;
          });
          this.money = this.exchangeOrderInfo.money;
          response.data.money = "****";
          this.formData = { ...this.formData, ...this.exchangeOrderInfo };
        }
      });
    },
    afterRead(file) {
      this.showLoding = true;
      var formData = new FormData();
      formData.append("picture", file.file);
      formData.append("code", this.code);
      formData.append("name", "picture");
      uploadExchangeImg(formData)
        .then((res) => {
          const response = res.data;
          if (response.code === "200") {
            this.formData.picture = response.data;
            checkImgFun(response.data).then((url) => {
              this.showImgUrl = url;
            });
            this.$toast.success("上传成功");
          } else {
            this.$toast.fail(response.msg);
          }
          this.showLoding = false;
        })
        .catch(() => {
          this.$toast.fail("上传失败,请重新上传");
          this.showLoding = false;
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
.wrapper {
  background: url("https://www.servicefun.cn/static/img/bg.png") no-repeat;
  overflow: auto;
  background-size: 100%;
  background-color: #f0f0f0;
  .picker-field.picker-inputed {
    /deep/ .van-field__control {
      color: #323233;
      -webkit-text-fill-color: #323233;
    }
  }
  .picker-field {
    /deep/ .van-cell__title {
        position: absolute;
        width: 100%;
        z-index: 1;
      color: #646566;
    }
    /deep/ .van-cell__value {
      color: #8e8e8e;
      padding-left: 100px;
    }
    /deep/ .van-field__control {
      color: #8e8e8e;
      -webkit-text-fill-color: #8e8e8e;
    }
  }
  .formWrapper {
    width: 340px;
    background: #fff;
    margin: 0 auto;
    margin-top: 36px;
    border-radius: 10px;
    overflow: hidden;
    padding-bottom: 20px;
  }

  .panel {
    .title {
      padding: 10px 16px;
    }

    /deep/ .van-uploader {
      width: 300px;
      padding: 10px 16px;
    }

    .upladerBtn {
      border: none;
      width: 300px;
      font-size: 40px;
      height: 240px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-image: url(https://www.servicefun.cn/static/img/exrample.jpeg);
    }
    .upladerBtn.supplementImg {
      background-image: none;
      background-color: #e2e2e2;
    }
  }

  .discription {
    padding: 10px 16px;
    font-size: 12px;
    color: #908c8c;

    p {
      margin-top: 6px;
      line-height: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/exchange/index.vue